import React, { useState } from 'react';

import Plantilla from './plantillas/Plantilla';

const Acerca = () => {
    return (<>
        <Plantilla id="Acerca"></Plantilla>
    </>);
};

export default Acerca;